module.exports = __webpack_public_path__ + "media/images/games/35gender/tinied/qImg1-5922bd222a3db8e79c7e515f4e2f03ef.png";